<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row" v-if="!admin.tenantId">
        <Select v-model="params.tenantId" placeholder="加盟商" clearable style="width:200px">
          <Option v-for="(item, index) in tenantList" :value="item.tenantId" :key="index">{{ item.realName }}</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <Select v-model="params.recoveryUserId" placeholder="回收员" clearable style="width:200px">
          <Option v-for="(item, index) in recoveryUserList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                    separator=" ~ " split-panels transfer
                    placeholder="创建时间" style="width: 200px"></DatePicker>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findVehicleWeighList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>过磅列表</div>
          <div>
            <ButtonGroup>
              <div style="margin-left: 0">
                过磅提醒：
                <i-switch v-model="switch1" @on-change="change" />
              </div>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">
        <template slot-scope="{row, index}" slot="startImg">
          <div class="j-vehicle-image" @click="previewImage(formatImage(row.startImg))">
            <img :src="row.startImg">
          </div>
        </template>

        <template slot-scope="{row, index}" slot="endImg">
          <div class="j-vehicle-image" @click="previewImage(formatImage(row.endImg))">
            <img :src="row.endImg">
          </div>
        </template>

        <template slot-scope="{row, index}" slot="realityWeight">
          <span v-if="row.startWeight && row.endWeight">{{row.endWeight - row.startWeight}}</span>
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" v-if="row.endWeight" @click="showVehicleOpe(row)">查看订单
          </Button>
          <!--                    <Button type="primary" size="small" style="margin-right: 5px" @click="isDelUser(row)">删除-->
          <!--                    </Button>-->
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <vehicle-ope ref="vehicleOpe" @changeDate="findVehicleWeighList"></vehicle-ope>

    <!-- 图片预览弹窗 -->
    <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
      <template scope="scope">
        <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
        {{ scope.options }}
      </template>
    </viewer>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import vehicleOpe from './components/vehicle-ope';

export default {
  name: "vehicle",
  data() {
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
      total: 0,
      dateInit: '',
      isTableLoading: false,
      images: [],
      showImage: false,
      // 参数
      params: {
        page: 1,
        rows: 10,
        recoveryUserId: '',
        startTime: '',
        endTime: '',
        tenantId: ''
      },
      recoveryUserList: [],
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '回收员',
          minWidth: 100,
          key: 'realName'
        },
        {
          title: '空车数据上传时间',
          minWidth: 140,
          key: 'startTime'
        },
        {
          title: '空车重量',
          minWidth: 80,
          key: 'startWeight'
        },
        {
          title: '空车图片',
          minWidth: 110,
          slot: 'startImg'
        },
        {
          title: '满车数据上传时间',
          minWidth: 140,
          key: 'endTime'
        },
        {
          title: '满车重量',
          minWidth: 80,
          key: 'endWeight'
        },
        {
          title: '满车图片',
          minWidth: 110,
          slot: 'endImg'
        },
        {
          title: '订单重量',
          minWidth: 120,
          key: 'countWeight'
        },
        {
          title: '过磅重量',
          minWidth: 120,
          slot: 'realityWeight'
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '过磅管理', url: '', icon: '', size: 0},
        {name: '过磅列表', url: '', icon: '', size: 0}
      ],
      tenantList: [],
      switch1: false
    }
  },
  created() {
    // 租户-列表查询
    this.findVehicleWeighList();
    this.findRecoveryUserList()
    // 查询配置接口
    this.getConfigKey();
  },
  methods: {
    // 车辆过磅-列表查询
    findVehicleWeighList() {
      this.isTableLoading = true;
      this.axios.post('/vehicleWeigh/findList', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询车辆过磅列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 回收员-列表查询
    findRecoveryUserList() {
      let params = {
        page: 1,
        rows: 20,
        isDisable: 0,
        tenantId: this.params.tenantId
      }
      this.axios.post('/recoveryUser/findList', params).then(res => {
        if (res.status == 200) {
          if (res.data.rows) {
            this.recoveryUserList = []
            res.data.rows.forEach(v => {
              let object = {
                value: v.recoveryUserId,
                label: v.realName
              }
              this.recoveryUserList.push(object)
            })
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收员列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 是否删除过磅信息
    isDelUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否删除当前过磅信息？`,
        onOk: () => {
          // this.$Message.info('您点击了确定.');
          this.deleteVehicle(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 删除
    deleteVehicle(row) {
      this.$Spin.show();
      this.axios.post('/vehicleWeigh/delete', {
        vehicleWeighId: row.vehicleWeighId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findVehicleWeighList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '删除失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '删除接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showVehicleOpe(row) {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$router.push({path: '/index/recovery-order',query:{
        recoveryUserId: row.recoveryUserId, startTime: row.startTime, endTime: row.endTime, orderState: 3
      }})
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.recoveryUserId = '';
      this.params.startTime = '';
      this.params.endTime = '';
      this.dateInit = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findVehicleWeighList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findVehicleWeighList();
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    previewImage(images) {
      this.images = images;
      this.$viewer.show();
    },
    // 格式化图片
    formatImage(image) {
      if (image) {
        return image.split(',')
      }
    },
    getConfigKey () {
      this.axios.post('/config/findConfigByKey', {configKey: 'vehicleWeigh'}).then(res => {
        if (res.status == 200) {
          if (res.data) {
            this.switch1 = res.data === '1'
          }
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询配置接口报错',
            duration: 0
          });
        }
      })
    },
    change (status) {
      let configValue = status ? '1' : '0'
      this.axios.post('/config/updateConfigByKey', {configKey: 'vehicleWeigh', configValue: configValue}).then(res => {
        if (res.status == 200) {
          let str = status ? '开启' : '关闭'
          let msg = '已' + str + '过磅提醒';
          this.$Message.info(msg);
        }
        if(res.status == 201){
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '修改配置接口报错',
            duration: 0
          });
        }
      })
    }
  },
  components: {
    hsBreadcrumb,
    vehicleOpe
  }
}
</script>

<style scoped>
.j-vehicle-image {
  width: 100px;
  height: 50px;
  padding: 5px;
  cursor:pointer;
}

.j-vehicle-image img {
  width: auto;
  height: 100%;
}
</style>